/**
 * Cle de signature du poste : ECDSA P-256, generee par WebCrypto et NON
 * exportable (plan, section 1.7). La CryptoKey privee est gardee telle quelle
 * dans IndexedDB : le navigateur la stocke sans jamais l'exposer en clair.
 * Seule la cle publique part au serveur, en JWK { kty, crv, x, y }.
 */
export const SIGNING_ALGORITHM = Object.freeze({ name: 'ECDSA', namedCurve: 'P-256' });

/**
 * @param {SubtleCrypto} subtle
 * @returns {Promise<{ private_key: CryptoKey, public_key: CryptoKey, public_jwk: object }>}
 */
export async function generateDeviceKey(subtle = globalThis.crypto && globalThis.crypto.subtle) {
    if (!subtle) throw new Error('WebCrypto indisponible');
    const pair = await subtle.generateKey(SIGNING_ALGORITHM, false, ['sign', 'verify']);
    if (pair.privateKey.extractable !== false) {
        // Garde-fou : la partie privee ne doit jamais pouvoir sortir du navigateur.
        throw new Error('La cle privee du poste serait exportable');
    }
    const jwk = await subtle.exportKey('jwk', pair.publicKey);
    return {
        private_key: pair.privateKey,
        public_key: pair.publicKey,
        public_jwk: { kty: jwk.kty, crv: jwk.crv, x: jwk.x, y: jwk.y },
    };
}
